import { useEffect } from "react"
import Categories from "../../../components/monaliza/category/Categories"




const Category = () => {


    return (
    <>
        <Categories/>
    </>
  )
}

export default Category